export const ISSUE_TYPE_HELP_TEXT_URL = '/secure/ShowConstantsHelp.jspa?decorator=popup#IssueTypes';

export const ISSUE_TYPE_PICKER_ELEMENT_ID =
	'issue-create.ui.modal.create-form.type-picker.issue-type-select';

export const OPTION_TYPE_CREATE_ISSUE_TYPE = 'CREATE_ISSUE_TYPE';
export const OPTION_TYPE_EDIT_ISSUE_TYPE = 'EDIT_ISSUE_TYPE';
export const OPTION_TYPE_MANAGE_ISSUE_TYPE = 'MANAGE_ISSUE_TYPE';

export const REFOCUS_DELAY_MS = 500;
